import { render, staticRenderFns } from "./EventPost.vue?vue&type=template&id=411fa49a&scoped=true"
import script from "./EventPost.vue?vue&type=script&lang=js"
export * from "./EventPost.vue?vue&type=script&lang=js"
import style0 from "./EventPost.vue?vue&type=style&index=0&id=411fa49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411fa49a",
  null
  
)

export default component.exports